import React, { useCallback, useEffect, useMemo, useState, lazy, Suspense } from 'react';
import { Tooltip } from 'react-tooltip';
import { Pagination } from "../../../../common/pagination";
import ModernPagination from "../../../../common/pagination/ModernPagination";
import Table from "../../../../common/element/Table";
import ClientInput from "../../../../common/element/Input/clientInput";

import { debounce } from "../../../../common/snippet/Debouncing";
import { setBreadcrumbs } from "../../../../redux/Admin/breadcrumbsSlice";
import { useDispatch, useSelector } from 'react-redux';
import { setsessionName } from '../../../../redux/Admin/sessionViewSlice';
import { selectUserData } from "../../../../redux/auth/authSelector";
import { useLocation, useNavigate } from "react-router-dom";
import Button from '../../../../common/element/Buttons';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {
  getCompanySessions,

} from '../../../../redux/CompanySession/companiesSessionSlice';
import {
  selectCompanySessionsList,
  selectCompanySessionsLoading,
  selectCompanySessionsTotal,
} from '../../../../redux/CompanySession/companiesSessionSelector';
import Heading from '../../../../common/element/Heading';
import ThreeDotBouncingLoader from '../../../../common/element/ButtonLoader/ThreeDotBouncingLoder';
import CommonIconButton from '../../../../common/icons/CommonIconButton';
import CopyLinkURLModal from '../../Admin/ProspectCompany/CopyLink';


// Extend dayjs with custom parse format plugin
dayjs.extend(customParseFormat);
const { Tr, Th, Td, THead, TBody } = Table;
const CompanySessions = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector(selectUserData);
  const [countData, setCountData] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const location = useLocation();
  const [isViewMode, setIsViewMode] = useState(false);

  const searchParams = new URLSearchParams(location.search);


  const [getFilterData, SetFilterData] = useState({
    page: 1,
    limit: 10,
    sort: "created_date",
    order: "desc",
    search: "",
  });

  // Accept plain name/value so we don't rely on React's synthetic event inside a debounced callback
  const handleSearch = (name, value) => {
    SetFilterData((prev) => ({
      ...prev,
      page: 1, // reset to first page whenever a new search is performed
      [name]: value,
    }));
  };

  // Create a debounced function that works with plain values (name, value)
  const debouncedSearch = useMemo(() => debounce((name, value) => {
    handleSearch(name, value);
  }), []);

  // Wrapper expected by the input component: extract name/value immediately and forward to debouncedSearch
  const inputchangehandler = useCallback((e) => {
    const name = e?.target?.name;
    const value = e?.target?.value ?? "";
    debouncedSearch(name, value.trim());
  }, [debouncedSearch]);

  const [allSessionsData, setAllSessionsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openCopyLinkModal, setOpenCopyLinkModal] = useState(false);
  const [selectedSessionLink, setSelectedSessionLink] = useState(null);

  const handlePageChange = (page) => {
    SetFilterData((prev) => ({ ...prev, page }));
  };

  // ✅ Helper: Format date and time together using dayjs
  const formatDateTime = (dateString) => {
    if (!dateString) return 'N/A';
    const parsedDate = dayjs(dateString);
    return parsedDate.isValid() ? parsedDate.format('DD/MM/YYYY') : dateString;
  };

  // Helper function to refresh sessions data
  const refreshSessionsData = () => {

    dispatch(getCompanySessions({
      company_id: "",
      page: getFilterData.page,
      limit: getFilterData.limit,
      search: getFilterData.search
    }));

  };


  const filteredData = useMemo(() => {
    if (!getFilterData.search) return allSessionsData;
    const searchValue = String(getFilterData.search ?? '').toLowerCase();

    const safeLower = (v) => String(v ?? '').toLowerCase();

    return allSessionsData.filter((item) =>
      safeLower(item.sessionName).includes(searchValue) ||
      safeLower(item.coach).includes(searchValue) ||
      safeLower(item.status).includes(searchValue) ||
      safeLower(item.toolName).includes(searchValue) ||
      safeLower(item.date).includes(searchValue)
    );
  }, [getFilterData.search, allSessionsData]);

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "completed":
        return "text-green-600 bg-green-50 ";
      case "upcoming":
        return "text-blue-600 bg-blue-50";
      case "cancelled":
        return "text-red-600 bg-red-50";
      case "ongoing":
        return "text-[#CA8A04] bg-[#FEF9C3]";
      default:
        return "text-gray-600 bg-gray-50";
    }
  };
  const startIndex = (getFilterData.page - 1) * getFilterData.limit;

  const sessionsFromStore = useSelector(selectCompanySessionsList);
  const sessionsLoading = useSelector(selectCompanySessionsLoading);
  const sessionsTotal = useSelector(selectCompanySessionsTotal);
  console.log(sessionsLoading, "sessionsLoadingsessionsLoading")
  useEffect(() => {
    const mapped = Array.isArray(sessionsFromStore)
      ? sessionsFromStore.map((cs) => {
        const session = cs.session || {};
        const coachUser = cs.coach?.coach?.user || {};
        const batches = Array.isArray(cs.batches) ? cs.batches.map((b) => b.batch_name).join(', ') : '';

        const assignments = Array.isArray(cs.assignments) ? cs.assignments : [];
        const assignmentNames = assignments.map(a => a.assignment_name?.trim()).filter(Boolean).join(', ');

        const formattedDate = formatDateTime(cs.session_date, cs.session_time);

        return {
          id: cs.company_session_id ?? session.session_id,
          sessionName: cs.session_name ?? '',
          date: formattedDate, // ✅ Using formatted date/time
          rawDate: cs.session_date, // Keep raw for reference
          rawTime: cs.session_time, // Keep raw for reference
          batch: batches,
          coach: `${coachUser.first_name ?? ''} ${coachUser.last_name ?? ''}`.trim(),
          status: cs.status ?? '',
          companyId: cs.company?.company_id || '',
          sessionUrl: cs.session_url || '',
          _raw: cs,
        };
      })
      : [];

    setAllSessionsData(mapped);
    setCountData(sessionsTotal || 0);
    const totalPagesFromApi = getFilterData.limit ? Math.ceil((sessionsTotal || 0) / getFilterData.limit) : 0;
    setTotalPages(totalPagesFromApi);
    setLoading(!!sessionsLoading);
  }, [sessionsFromStore, sessionsLoading, sessionsTotal]);

  useEffect(() => {

    dispatch(getCompanySessions({ company_id: "", page: getFilterData.page, limit: getFilterData.limit, search: getFilterData.search }));
  }, [getFilterData.page, getFilterData.limit, getFilterData.search]);

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Company Sessions",
          url: "/companySession",
          home: "/dashboard",
        },
      ])
    );
  }, []);

  return (
    <React.Fragment>
      {/* ✅ Global Tooltip Component */}
      <Tooltip
        id="session-tooltip"
        place="top"
        className="!bg-gray-900 !text-white !text-xs !rounded-lg !px-3 !py-2 !z-50 !max-w-[250px]"
      />
      <div className="w-80 h-10 text-start">
        <Heading>Company Session</Heading>
      </div>
      <div className="flex justify-between items-center">
        <p className="font-lato not-italic font-semibold text-[30px] leading-[38px] text-[#101828] my-3 text-start"></p>
        <div className="input-wrapper mb-4">
          <div className="input-suffix-start left-3.5">
            <img src="/assets/icons-svg/search-lg.svg" alt="" className="h-5" />
          </div>
          <ClientInput
            type="text"
            className="input pl-10 w-80 input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="Search"
            inputchangehandler={inputchangehandler}
            name={"search"}
          />
        </div>
      </div>


      <div className="border rounded-lg border-gray-200">
        <div className="">
          <Table>
            <THead>
              <Tr className="bg-gray-50">
                <Th className="text-start px-4 py-3 font-lato font-medium text-sm leading-[1.5] text-[#475467] whitespace-nowrap">S No.</Th>
                <Th className="text-start px-4 py-3 font-lato font-medium text-sm leading-[1.5] text-[#475467] whitespace-nowrap">Session Name</Th>
                <Th className="text-start px-4 py-3 font-lato font-medium text-sm leading-[1.5] text-[#475467] whitespace-nowrap">Batch Name </Th>
                <Th className="text-start px-4 py-3 font-lato font-medium text-sm leading-[1.5] text-[#475467] whitespace-nowrap">Status</Th>
                <Th className="text-start px-4 py-3 font-lato font-medium text-sm leading-[1.5] text-[#475467] whitespace-nowrap">Coach</Th>
                <Th className="text-start px-4 py-3 font-lato font-medium text-sm leading-[1.5] text-[#475467] whitespace-nowrap">Date</Th>





                <Th className="text-center px-4 py-3 font-lato font-medium text-sm leading-[1.5] text-[#475467] whitespace-nowrap">Actions</Th>
              </Tr>
            </THead>

            <TBody>
              {sessionsLoading && (allSessionsData?.length === 0) ? (
                <Tr>
                  <Td colSpan={12} className="text-center py-8">
                    <ThreeDotBouncingLoader />
                  </Td>
                </Tr>
              ) : (filteredData?.length > 0 ? (
                filteredData.map((item, index) => {
                  const status = item.status?.toUpperCase();

                  return (
                    <Tr key={item.id} className="border-b hover:bg-gray-50">
                      <Td className="text-start px-4 py-3 font-lato font-medium text-sm leading-[1.5] text-[#1D2939] whitespace-nowrap">
                        {String(startIndex + index + 1).padStart(2, "0")}
                      </Td>
                      <Td className="text-start px-4 py-3 font-lato font-medium text-sm leading-[1.5] text-[#1D2939] whitespace-nowrap">{item.sessionName}</Td>

                      <Td className="text-start px-4 py-3 font-lato font-medium text-sm leading-[1.5] text-[#1D2939] whitespace-nowrap">{item.batch}</Td>

                      <Td className="text-start px-4 py-3 font-lato font-medium text-sm leading-[1.5] text-[#1D2939] whitespace-nowrap">
                        <span
                          className={`px-3 py-1 rounded-full text-xs font-medium capitalize ${getStatusColor(status)}`}
                        >
                          {item.status}
                        </span>
                      </Td>
                      <Td className="text-start px-4 py-3 font-lato font-medium text-sm leading-[1.5] text-[#1D2939] whitespace-nowrap">{item.coach ? item.coach : "N/A"}</Td>

                      <Td className="text-start px-4 py-3 font-lato font-medium text-sm leading-[1.5] text-[#1D2939] whitespace-nowrap">{item.date}</Td>


                      <Td className="whitespace-nowrap">
                        <div className="flex items-center gap-1">
                          <CommonIconButton
                            type="view"
                            onClick={() => {
                              // persist session name to redux so view can show it in breadcrumbs
                              dispatch(setsessionName(item.sessionName || ''));
                              navigate(`/companySession/view?companyId=${item?.companyId}&SessionId=${item.id}`);
                              console.log(item, "item?.company?.company_id");
                            }} />

                          {item.sessionUrl && (
                            <p
                              className="w-10 h-10 flex items-center justify-center cursor-pointer"
                              onClick={() => {
                                setSelectedSessionLink({ generateUrl: item.sessionUrl });
                                setOpenCopyLinkModal(true);
                              }}
                            >
                              <CommonIconButton type="link" />
                            </p>
                          )}
                        </div>
                      </Td>
                    </Tr>
                  )
                })
              ) : (
                <Tr>
                  <Td colSpan={12} className="text-center font-lato font-medium text-sm leading-[1.5] text-[#1D2939] py-6">
                    {sessionsLoading ? <ThreeDotBouncingLoader /> : 'No matching records found'}
                  </Td>
                </Tr>
              ))}
            </TBody>
          </Table>
        </div>
      </div>

      <div className="flex justify-between items-center mt-3">
        <Pagination
          totalCount={countData}
          pageNumber={getFilterData.page}
          displayPage={allSessionsData?.length}
          UpdatePageLimit={(limit) => SetFilterData((prev) => ({ ...prev, limit }))}
          UpdatePage={(page) => SetFilterData((prev) => ({ ...prev, page }))}
        />

        {countData > 0 && totalPages > 1 && (
          <ModernPagination
            totalPages={totalPages}
            currentPage={getFilterData.page}
            onPageChange={handlePageChange}
          />
        )}
      </div>


      <CopyLinkURLModal
        dialogOpen={openCopyLinkModal}
        onDialogClose={() => setOpenCopyLinkModal(false)}
        onSubmit={() => setOpenCopyLinkModal(false)}
        companyData={selectedSessionLink}
      />

    </React.Fragment>
  );
};

export default CompanySessions;